

export const overlayDivStyles = {
  marginTop: '30vh'
};
